import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindResultsFilter.call(this)
    bindCheckAllCheckbox.call(this)
    submitBulkAction.call(this)
  }
};

var bindResultsFilter = function() {
  let elem = this.root
  this.resultsFilter = new ResultsFilterWidget(elem)
}

var fetchBulkAction = function(bulkAction, groupId, listOfVehicle) {
  $.ajax({
    url: '/backend/vehicles/bulk_action.json',
      dataType: 'json',
      method: 'PUT',
      data: {
        bulk_action: bulkAction,
        group_id: groupId,
        list_of_vehicle: listOfVehicle,
      },
      success: function (r) {
        console.log('Succeed');
      }
  });
}

var submitBulkAction = function() {
  this.root.find('#submit-bulk-action').on("click", (e) => {
    const selectAll = document.querySelector('.check_all_group').checked;
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const groupId = document.querySelector('#by_bulk_group_action').value;
    const bulkAction = document.querySelector('#bulk_action').value;
    let listOfVehicle = [];

    if (selectAll) {
      for (var i=1, n = checkboxes.length; i < n; i++) {
        listOfVehicle.push(checkboxes[i].id)
      }
    } else {
      for (var i=1, n = checkboxes.length; i < n; i++) {
        if (checkboxes[i].checked) {
          listOfVehicle.push(checkboxes[i].id)
        }
      }
    }
    fetchBulkAction(bulkAction, groupId, listOfVehicle);
  })
}

var bindCheckAllCheckbox = function() {
  this.root.on('.check_all_group').on("click", (e) => {
    if (e.target.name === 'All') {
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      for (var i=0, n = checkboxes.length; i < n; i++) {
        checkboxes[i].checked = document.querySelector('.check_all_group').checked;
      }
    }
  })
}

export default Controller;
